import React from "react";
import { cn } from "@jem-open/jem-ui";

export const Th = ({
  children,
  align = "left",
  className,
}: {
  children: React.ReactNode;
  align?: "left" | "right";
  className?: string;
}): JSX.Element => (
  <th
    className={cn(
      "px-sm py-xs font-semibold text-greyscale-text-caption uppercase text-[10px] sm:text-xs whitespace-nowrap",
      align === "right" ? "text-right" : "text-left",
      className
    )}
  >
    {children}
  </th>
);

export const Td = ({
  children,
  align = "left",
  mono,
  className,
}: {
  children: React.ReactNode;
  align?: "left" | "right";
  mono?: boolean;
  className?: string;
}): JSX.Element => (
  <td
    className={cn(
      "px-sm py-xs text-greyscale-text-body whitespace-nowrap",
      align === "right" ? "text-right" : "text-left",
      mono && "font-mono",
      className
    )}
  >
    {children}
  </td>
);
